/* OSDTG header search panel: popular picks on focus, live matches while typing. */
(function () {
  if (window.__osdtgSearch) return;
  window.__osdtgSearch = true;

  var SECTION = 'osdtg-search-panel';
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  function init() {
    var wrap = document.querySelector('[data-osdtg-search]');
    var panel = document.getElementById('OsdtgSearchPanel');
    if (!wrap || !panel) return;
    var input = wrap.querySelector('input[name="q"]');
    var body = panel.querySelector('[data-osdtg-sp-content]');
    var closeBtn = panel.querySelector('[data-osdtg-sp-close]');
    var cache = {};
    var timer = null;
    var lastTerm = null;

    function extract(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-osdtg-sp-body]');
      return el ? el.outerHTML : '';
    }

    function load(term) {
      if (term === lastTerm) return;
      lastTerm = term;
      var key = term || '__empty__';
      if (cache[key]) {
        body.innerHTML = cache[key];
        return;
      }
      panel.classList.add('is-loading');
      var url = term
        ? root + 'search/suggest?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query&resources[limit]=10&resources[options][unavailable_products]=last&section_id=' + SECTION
        : root + '?section_id=' + SECTION;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var out = extract(html);
          cache[key] = out;
          if (lastTerm === term) body.innerHTML = out;
        })
        .catch(function () {
          if (lastTerm === term) body.innerHTML = '<p class="osdtg-sp__empty">Search is taking a break. Press Enter to see results.</p>';
        })
        .finally(function () { panel.classList.remove('is-loading'); });
    }

    // Open below the category menu bar (when present) so the menu stays visible.
    function place() {
      var host = panel.offsetParent || panel.parentElement;
      var bar = document.querySelector('.osdtg-catbar');
      if (!host) return;
      var hostTop = host.getBoundingClientRect().top;
      // The bar is hidden on phones/tablets (side menu instead); fall back to the header.
      var anchor = bar && bar.offsetParent ? bar.getBoundingClientRect().bottom : host.getBoundingClientRect().bottom;
      panel.style.top = Math.max(0, Math.round(anchor - hostTop)) + 'px';
    }
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
    window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });

    function open() {
      if (panel.hidden) {
        panel.hidden = false;
        place();
        input.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('osdtg-sp-open');
      }
      load(input.value.trim());
    }

    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('osdtg-sp-open');
    }

    input.addEventListener('focus', open);
    // Native search inputs consume Escape (to clear), so close from the input itself too.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      if (panel.hidden) open();
      timer = setTimeout(function () { load(input.value.trim()); }, 220);
    });
    closeBtn && closeBtn.addEventListener('click', function () { close(); input.blur(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('mousedown', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !wrap.contains(e.target)) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
